import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule, MatRippleModule, MatSidenavModule, MatToolbarModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { TbWaterfallModule } from "../../tb/tb-waterfall/tb-waterfall.module";
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { FranchiseComponent } from "./franchise.component";
import { FranchiseDashboardComponent } from "./franchise-container/franchise-dashboard/franchise-dashboard.component";
import { RetailerDashboardComponent } from "./franchise-container/retailer-dashboard/retailer-dashboard.component";




@NgModule({
  declarations: [FranchiseComponent, FranchiseDashboardComponent, RetailerDashboardComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    MatRippleModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    TbWaterfallModule,
    RouterModule,
    FormsModule,
    OverlayModule,

  ],
  exports: [FranchiseComponent]
})
export class FranchiseModule { }
